<div class="kt-subheader kt-grid__item" [hidden]="subheaderService.disabled$ | async" id="kt_subheader">
	<div class="kt-container" [ngClass]="{ 'kt-container--fluid': fluid }">
		<div class="kt-subheader__wrapper">
			
			<!-- Breadcrumb nav path -->
			<div class="breadcrumb-container" *ngIf="breadcrumbs.length > 0">
				<a class="breadcrumb-home-link" routerLink="/overall/1">
					<mat-icon>home</mat-icon>
				</a>
				<ng-container *ngFor="let item of breadcrumbs; let last = last">
					<mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
					<a [routerLink]="item.page" [queryParams]="item.queryParams" class="breadcrumb-link" [class.breadcrumb-link--active]="last">
						{{ item.title }}
					</a>
				</ng-container>
			</div>

			<!-- Dynamic Current Timestamp / Meta section -->
			<div class="subheader-meta-section">
				<mat-icon class="meta-icon">schedule</mat-icon>
				<span class="meta-date">{{ today | date: 'MMM dd, yyyy' }}</span>
			</div>

		</div>
	</div>
</div>
<!-- end:: Content Head -->
